import React, { useEffect } from 'react'
import { Link, useSearchParams, useNavigate } from 'react-router-dom'
import { useAuth } from 'hooks/auth'
import api, { APIError } from 'helpers/api'
import { safeLocalStorage } from 'helpers/localStorage'
import { HOME, SIGN_IN } from 'routes'
import { redirectTo } from 'helpers/redirect'
import { SIGNIN_EMAIL_KEY } from 'app-constants'
import { clearMasqueradeToken } from 'helpers/auth'

const SAMLComplete: React.FC = () => {
  const { updateUser } = useAuth()
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const [loading, setLoading] = React.useState(true)
  const [error, setError] = React.useState(false)
  const [errorMessage, setErrorMessage] = React.useState('')

  const completeSSO = async () => {
    try {
      const encodedData = searchParams.get('data')

      if (!encodedData) {
        console.error('No user data received')
        navigate(redirectTo(SIGN_IN))
        return
      }

      const decodedData = JSON.parse(decodeURIComponent(encodedData))
      const { user } = decodedData

      if (!user) {
        navigate(redirectTo(SIGN_IN))
        return
      }

      if (user.email) {
        safeLocalStorage.setItem(SIGNIN_EMAIL_KEY, user.email.toLowerCase())
      }

      clearMasqueradeToken()
      await updateUser(user)
      setLoading(false)

      // Fetch me to get all the other info
      const resp = await api.getMe()
      await updateUser(resp.data)
      navigate(redirectTo(HOME))
    } catch (e) {
      if (e instanceof APIError) {
        setErrorMessage(e.message)
      }

      setError(true)
      setLoading(false)
      navigate(redirectTo(SIGN_IN))
    }
  }

  useEffect(() => {
    completeSSO()
  }, [])

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <p className="text-muted">Completing authentication...</p>
        </div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <p className="text-red">Authentication failed. Please try again.</p>
          <button onClick={() => navigate(redirectTo(SIGN_IN))} className="mt-4 text-blue hover:underline">
            Return to Login
          </button>
        </div>
      </div>
    )
  }

  return (
    <div className="bg-really-light-blue flex flex-1 items-center justify-center overflow-hidden box-border h-screen w-full px-8">
      <div className="h-fit flex flex-col bg-surface border border-divider-strong p-8 shadow-heavy rounded text-body w-[550px]">
        <h1 className="mb-12 text-2xl">Signing you into your Morta account</h1>
        {error && (
          <div>
            <p>
              {errorMessage === '' && (
                <span>
                  There was an error signing your into your account. If the problem persists contact the adminstrator on
                  your SSO account.
                </span>
              )}
              {errorMessage !== '' && <span>{errorMessage}</span>}
            </p>

            <br />
            <p>
              Return to <Link to={SIGN_IN}>sign in page</Link>.
            </p>
          </div>
        )}
      </div>
    </div>
  )
}

export default SAMLComplete
